<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-商品兑换-添加
    -->
    <el-dialog
    title="添加商品兑换"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加商品兑换</div>

      <el-form-item label="商品兑换名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入商品兑换名称" class="max-w460"></el-input>
      </el-form-item>
      
      <!-- 新增的三个字段 -->
      <el-form-item label="兑换积分" prop="points">
        <el-input v-model="form.points" placeholder="请输入兑换所需积分" class="max-w460" type="number">
          <template slot="append">积分</template>
        </el-input>
      </el-form-item>
       <el-form-item label="商品价值" prop="points">
        <el-input v-model="form.marketPrice" placeholder="请输入商品价值" class="max-w460" type="number">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="库存" prop="stock">
        <el-input v-model="form.stock" placeholder="请输入商品库存" class="max-w460" type="number">
          <template slot="append">件</template>
        </el-input>
      </el-form-item>
      
      <el-form-item label="虚拟兑换数量" prop="virtual_sales">
        <el-input v-model="form.virtual_sales" placeholder="请输入虚拟兑换数量" class="max-w460" type="number">
          <template slot="append">件</template>
        </el-input>
      </el-form-item>

      <el-form-item label="商品兑换bannar：" prop="model.image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.bannar">
            <transition-group>
              <div v-for="(item, index) in form.bannar" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('bannar')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="商品兑换图片：" prop="model.image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div v-for="(item, index) in form.image" :key="item.file_path">
                <div class="item">
                  <img v-img-url="item.file_path" alt="file_path"/>
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('album')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="商品兑换介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460" type="number"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
</template>

<script>
import ExchangeApi from '@/api/exchange.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    // 验证数字的规则
    const validateNumber = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('该字段不能为空'));
      } else if (value < 0) {
        callback(new Error('数值不能小于0'));
      } else if (!/^\d+$/.test(value)) {
        callback(new Error('请输入有效的数字'));
      } else {
        callback();
      }
    };

    return {
      isupload: false,
      isImg: false,  
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
       supply_id:this.$route.query.supply_id,
      form: {
        name: '',
        code: 'custom',
        points: 0, // 兑换积分
        stock: 0,  // 库存
        virtual_sales: 0, // 虚拟兑换数量
        image: [],
        sort: 50,
        intro: "",
        bannar: []
      },
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入商品兑换名称', trigger: 'blur' }],
        points: [
          { required: true, message: '请输入兑换积分', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '请输入库存', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        virtual_sales: [
          { required: true, message: '请输入虚拟兑换数量', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    chooseCategory(){
      this.iscategorya = true;
    },
    
    openUpload(e) {
      this.isupload = true;
    },

    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    cancelFunc() {
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      
      // 验证新增字段
      if (form.points < 0) {
        self.$message({
          message: "兑换积分不能小于0",
          type: 'error'
        });
        return;
      }
      
      if (form.stock < 0) {
        self.$message({
          message: "库存不能小于0",
          type: 'error'
        });
        return;
      }
      
      if (form.virtual_sales < 0) {
        self.$message({
          message: "虚拟兑换数量不能小于0",
          type: 'error'
        });
        return;
      }
      
      if(form.image.length <= 0){
        self.$message({
          message: "请上传图片",
          type: 'error'
        });
        return;
      }
      
      form.intro = this.$refs.ue.getUEContent();
      form.supply_id = self.supply_id
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ExchangeApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    deleteImg(index, code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      } else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/exchange/index/part/add.vue